import fetchWithTimeout from "api/fetchWithTimeout"
import config from "lib/config"
import { api } from "apiServer"
export async function getPropsHomePage() {
  let resData = {
    screenblocks: [],
    slides: [],
    leagues: []
  }
  try {
    // eslint-disable-next-line no-undef, no-async-promise-executor
    const [screenblocksRes, slidesRes, leaguesRes] = await Promise.all([
      fetchWithTimeout(`${config.BASE_API_URL}/publish/events/`),
      fetchWithTimeout(`${config.BASE_API_URL}/publish/slides/`),
      fetchWithTimeout(`${config.BASE_API_URL}/publish/home/leagues/`)
    ])
    if (screenblocksRes.ok) {
      const screenblocksData = await screenblocksRes.json()
      if (screenblocksData?.data?.length) resData.screenblocks = screenblocksData.data
    }
    if (slidesRes.ok) {
      const slidesData = await slidesRes.json()
      if (slidesData?.data?.length) resData.slides = slidesData.data
    }
    if (leaguesRes.ok) {
      const leaguesData = await leaguesRes.json()
      if (leaguesData?.data?.length) resData.leagues = leaguesData.data
    }
    if (typeof window !== "undefined" && typeof sessionStorage !== "undefined") {
      const timestamp = Date.now()
      sessionStorage.setItem("lastFetchTime", timestamp)
    }
    return resData
  } catch (error) {
    console.log("getPropsHomePage", error)
    throw resData
  }
}
export function getPropsPost(slug) {
  // eslint-disable-next-line no-undef, no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    let resData = {
      menus: [],
      articles: [],
      topNews: []
    }
    try {
      const __menus = fetch(`${config.BASE_API_URL}/publish/categories/all/`)
      const __articles = fetch(`${config.BASE_API_URL}/publish/articles/detail/relate-to-cate/${slug}/`)
      const __topNews = fetch(`${config.BASE_API_URL}/publish/articles/hot/tin-noi-bat/`)
      // eslint-disable-next-line no-undef
      const response = await Promise.all([__menus, __articles, __topNews])
      if (response[0].ok) {
        const _menus = await response[0].json()
        if (_menus?.data?.length > 0) resData.menus = _menus.data
      }
      if (response[1].ok) {
        const _articles = await response[1]?.json()
        if (_articles?.data?.length) resData.articles = _articles.data
      }
      if (response[2].ok) {
        const _topNews = await response[2].json()
        if (_topNews?.data?.length) resData.topNews = _topNews.data
      }
      resolve(resData)
    } catch (error) {
      console.log("getPropsPost", error)
      reject(resData)
    }
  })
}
export function getPropsCategoryPage(req, query, res) {
  res.setHeader("Cache-Control", "public, s-maxage=10, stale-while-revalidate=29")
  // eslint-disable-next-line no-undef, no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    let resData = {
      lists: [],
      id: ""
    }
    const { cookies } = req
    const { id } = query
    try {
      if (id === "esports") {
        const { success, data } = await api.getDetailCategory(cookies?.accessToken, id, { menu_code: "ESPORTS" })
        if (success) {
          resData.lists = data
          resData.id = id
        }
      } else {
        const { success, data } = await api.getDetailCategory(cookies?.accessToken, id, {})
        if (success) {
          resData.lists = data
          resData.id = id
        }
      }
      resolve(resData)
      if (typeof window !== "undefined" && typeof sessionStorage !== "undefined") {
        const timestamp = Date.now()
        sessionStorage.setItem("lastFetchTime", timestamp)
      }
    } catch (error) {
      console.log("getPropsCategoryPage", error)
      reject(resData)
    }
  })
}
export function getPropsSlugPage(req, query, res) {
  // eslint-disable-next-line no-undef, no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    let resData = {
      lists: [],
      slug: "",
      video: {}
    }
    const { cookies } = req
    const { slug } = query
    try {
      const { data, block } = await api.getFullByBlock(cookies?.accessToken, slug, {
        page_num: 1,
        page_size: 24
      })
      resData.lists = data
      resData.slug = slug
      resData.video = block
      resolve(resData)
      if (typeof window !== "undefined" && typeof sessionStorage !== "undefined") {
        const timestamp = Date.now()
        sessionStorage.setItem("lastFetchTime", timestamp)
      }
    } catch (error) {
      console.log("getPropsSlugPage", error)
      reject(resData)
    }
  })
}
